import ApiService from '../ApiService';
import Axios from 'axios';

const AuthorizationsService = {

    async getAuthorizations(userId) {
        return await ApiService.customRequest({
            url: '/authorizations',
            method: 'GET',
            headers: {
                user: userId
            }
        })
    },
    async getAppOrderPatient(identification) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/orders/getAppOrderPatient`,
            data: {
                identification: identification.toString()
            },
            method: 'POST'
        })
    },
    async getImportations() {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/importations/all`,
            method: 'GET'
        })
    }
}

export default AuthorizationsService;